// app/components/thailand-premium-tapioca-starch-products/specRows.ts
export type BaseRow = {
  name: string;
  name_zh: string;
  data1: string;
  data2: string;
};

export function createRow(
  name: string,
  name_zh: string,
  data1: string,
  data2: string
): BaseRow {
  return { name, name_zh, data1, data2 };
}

export const baseRows1: BaseRow[] = [
  createRow("Starch Content", "淀粉含量", "80", "%Min"),
  createRow("Moisture Content", "水分", "13", "%Max"),
  createRow("Pulp Content", "纤维", "0.2", "cc./50 g. Max"),
  createRow("pH", "酸碱度", "5.0-7.0", "Max"),
  createRow("Ash Content", "灰分", "0.2", "%Max"),
  createRow("Viscosity", "粘胶度", "700", "B.U.  Min"),
  createRow("Whiteness", "白度", "90", "%Min"),
  createRow("Sulfur dioxide (SO2) Content", "二氧化硫", "30", "ppm Max"),
];

export const baseRows2: BaseRow[] = [
  createRow("Starch Content", "淀粉含量", "80", "%Min"),
  createRow("Moisture Content", "水分", "13", "%Max"),
  createRow("Pulp Content", "纤维", "0.2", "cc./50 g. Max"),
  createRow("pH", "酸碱度", "5.0-7.0", "Max"),
  createRow("Ash Content", "灰分", "0.2", "%Max"),
  createRow("Viscosity", "粘胶度", "700", "B.U.  Min"),
  createRow("Whiteness", "白度", "90", "%Min"),
  createRow("Sulfur dioxide (SO2) Content", "二氧化硫", "100", "ppm Max"),
];
